export const isAICCSessionSelector = state => state.aicc.isAICCSession;
